import React, { useEffect, useState } from "react";
import moment from "moment";

// External components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Translation
import { useTranslation } from "react-i18next";

// APIs
import getPhishingCanaryWhitelist from "api/phishingCanaryWhitelist/getPhishingCanaryWhitelist";

// MUI
import Tooltip from "@mui/material/Tooltip";
import { Icon, IconButton } from "@mui/material";
// import { useMaterialUIController } from "context";
import SweetAlert from "react-bootstrap-sweetalert";

const PhishingCanaryWhitelist = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [showHttpsHeaders, setShowHttpHeader] = useState(false);
  const [httpHeaders, setHttpHeaders] = useState(null);
  //   const [controller] = useMaterialUIController();
  //   const { user } = controller;

  const getData = async () => {
    try {
      const { results } = await getPhishingCanaryWhitelist();
      //   console.log("results", results);
      setData(results);
    } catch (e) {
      console.log("error --->", e);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  function getHttpHeadersContent(content) {
    if (content && Object.keys(content) && Object.keys(content).length > 0) {
      return (
        <div
          style={{
            textAlign: "left",
            fontSize: "18px",
            display: "flex",
            flexDirection: "column",
            gap: "10px 0",
          }}
        >
          {Object.keys(content).map((el, index) => {
            return (
              <div key={`http-header-for-element-${index.toString()}`}>
                {el}: <span style={{ fontWeight: "bold" }}>{content[el] || ""}</span>
              </div>
            );
          })}
        </div>
      );
    }
    return null;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {showHttpsHeaders ? (
        <SweetAlert
          style={{ display: "block", position: "relative", textAlign: "left" }}
          title={t("phishingCanaryWhitelist.http_headers")}
          onConfirm={() => {
            setShowHttpHeader(false);
            setHttpHeaders(null);
          }}
          confirmBtnText={t("ok")}
          confirmBtnCssClass="popupCloseButton"
          confirmBtnStyle={{
            boxShadow: "none",
          }}
        >
          {getHttpHeadersContent(httpHeaders)}
        </SweetAlert>
      ) : null}
      {/* Title */}
      <h2 className="page-title">Phishing Canary Whitelist</h2>

      {/* Page description */}
      <p style={{ fontSize: "small" }}>{t("phishingCanaryWhitelist.page_description")}</p>

      {/* Table */}
      <div className="table_users_list" style={{ marginTop: "25px" }}>
        <table className="table-content" cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th style={{ textAlign: "center" }}>{t("phishingCanaryWhitelist.date")}</th>
              <th style={{ textAlign: "center" }}>{t("phishingCanaryWhitelist.domain")}</th>
              <th style={{ textAlign: "center" }}>
                {t("phishingCanaryWhitelist.original_referrer")}
              </th>
              <th style={{ textAlign: "center" }}>{t("phishingCanaryWhitelist.http_headers")}</th>
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0
              ? data.map((incident) => (
                  <tr key={incident.id} style={{ textAlign: "center" }}>
                    <td>{moment(incident.date).format("DD/MM/YYYY")}</td>
                    <td>{incident.domain || "N/A"}</td>
                    <td>{incident.fullReferer || "N/A"}</td>
                    <td>
                      {incident.httpHeaders &&
                      Object.keys(incident.httpHeaders) &&
                      Object.keys(incident.httpHeaders).length > 0 ? (
                        <IconButton
                          onClick={() => {
                            setShowHttpHeader(!showHttpsHeaders);
                            setHttpHeaders(incident.httpHeaders);
                          }}
                          size="small"
                          disableRipple
                        >
                          <Icon fontSize="medium">info</Icon>
                        </IconButton>
                      ) : (
                        <Tooltip
                          title={t("phishingCanaryWhitelist.http_headers_missing_tooltip")}
                          placement="top"
                        >
                          <Icon fontSize="medium">close</Icon>
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </table>
      </div>
    </DashboardLayout>
  );
};

export default PhishingCanaryWhitelist;
